import {
  warehouseOptionsSelector,
  warehouseOptionTokensSelector,
} from '../../../../data/warehouses.js'
import {useSelector} from '../../../../store.js'
import FilterPanel from '../../../OrderListPage/Modals/OrderListFilterModal/FilterPanel.js'
import {
  modalFormSelector,
  updateModalForm,
  SENDING_WAREHOUSE_FILTER_PANEL,
} from './transferListFilterModalFunctions.js'

export default function SendingWarehouseFilterPanel() {
  const form = useSelector(modalFormSelector)
  const warehouseOptions = useSelector(warehouseOptionsSelector)
  const warehouseOptionTokens = useSelector(warehouseOptionTokensSelector)

  return (
    <FilterPanel
      id={SENDING_WAREHOUSE_FILTER_PANEL}
      label="Sending Warehouses"
      searchPlaceholder="Search for a warehouse filter..."
      options={warehouseOptions}
      optionTokens={warehouseOptionTokens}
      selected={form.sending_warehouse_id}
      onSelect={(option) => {
        const sending_warehouse_id = form.sending_warehouse_id.filter(
          (id) => id !== option.value,
        )

        if (sending_warehouse_id.length === form.sending_warehouse_id.length) {
          sending_warehouse_id.push(option.value)
        }

        updateModalForm({sending_warehouse_id})
      }}
    />
  )
}
